module.exports = __webpack_public_path__ + "img/Sent.d0c32438.svg";